module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top_text"
  }, [_c('v-icon', [_vm._v("beenhere")]), _vm._v("소재별 리포트")], 1), _vm._v(" "), _c('div', {
    staticClass: "topTableWrap"
  }, [_c('CreativeTable', {
    attrs: {
      "campaignType": _vm.campaignType,
      "viewData": _vm.viewData,
      "isExcel": _vm.isExcel,
      "tab": this.tab
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00eb8f71","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/creative/CreativeImp.vue
// module id = 825
// module chunks = 1